import { barHtml } from "./kit";

/**
 * "Resuming battle…" over the cloud wipe while a long suspended battle replays in chunks (main.ts). Only shown once
 * the replay has taken longer than a blink, so a short resume never flashes it.
 */
export class ResumeProgress {
  private readonly el: HTMLDivElement;
  private readonly fill: HTMLElement;

  constructor(parent: HTMLElement) {
    this.el = document.createElement("div");
    this.el.className = "resumeprog";
    this.el.innerHTML = `<div class="plate"><b class="disp">Rejoining the battle</b>${barHtml(0, "gold")}</div>`;
    this.fill = this.el.querySelector<HTMLElement>(".fill")!;
    parent.append(this.el);
  }

  set(fraction: number): void { this.fill.style.width = `${Math.round(Math.max(0, Math.min(1, fraction)) * 100)}%`; }

  dispose(): void { this.el.remove(); }
}
